export default __webpack_public_path__ + "static/illustration-periodic-compound-3f33403b617fd9aa1daf3f5a7ad34fc4.svg";